<template>
  <div>
    <h1>{{ msg }}</h1>
    <div id="reportViewer1">loading...</div>
  </div>
</template>

<script>
import '../../assets/ReportViewer/js/telerikReportViewer-16.0.22.119.min.js';
import '../../assets/ReportViewer/js/telerikReportViewer.kendo-16.0.22.119.min.js';

import { mapGetters } from 'vuex';
import { config } from '@/config.js';

export default {
  name: 'ReportViewerTest',
  data() {
    return {
      msg: '',
    };
  },
  computed: {
    ...mapGetters(['reporteActivo', 'parametrosReporte']),
  },
  mounted() {
    console.log(this.reporteActivo);
    console.log(this.parametrosReporte);

    console.log(window.location.href);

    var url = new URL(window.location.href);

    var reporte = url.searchParams.get('reporte');

    if (reporte) reporte = url.searchParams.get('reporte').replace(/_/g, ' ');
    else reporte = this.reporteActivo;

    console.log(reporte);

    let solicitudId = this.parametrosReporte[0];

    console.log(solicitudId);

    console.log('config.api.url');
    console.log(config.api.url);

    this.$nextTick(function () {
      $('#reportViewer1').telerik_ReportViewer({
        serviceUrl: this.$store.state.ambiente.url + 'Reports',
        reportSource: {
          report: reporte,
          parameters: {
            CreditoId: solicitudId,
            MostrarPrimeraPagina: true,
            MostrarCartasNacion: true,
            MostrarDAChubut: false,
          },
        },
        viewMode: telerikReportViewer.ViewModes.INTERACTIVE,
        scaleMode: telerikReportViewer.ScaleModes.SPECIFIC,
        scale: 1.0,
        sendEmail: { enabled: true },
        updateUi: function (e, args) {
          resizeViewer();
        },
        // Resize the viewer when new report is loaded in the viewer
        pageReady: function (e, args) {
          resizeViewer();
        },
      });
    });
  },
  methods: {
    showLocalStorage() {
      console.log(localStorage);
    },
  },
};

function resizeViewer() {
  var pageHeight =
      $('.trv-pages-area .trv-page-wrapper').height() +
      $('.trv-nav').outerHeight() +
      2, // Calcolate the report page height
    parametersAreaDom = $('.trv-parameters-area'),
    parametersAreaVisible = !parametersAreaDom.hasClass('k-state-collapsed'), //
    parametersAreaVertical = parametersAreaDom.hasClass('-vertical'),
    viewer = $('#reportViewer1'),
    viewerHeight = viewer.height();

  console.log(pageHeight);

  if (parametersAreaVisible && parametersAreaVertical) {
    pageHeight += 140;
  }

  if (viewerHeight !== pageHeight) {
    viewer.height(pageHeight);
    var documentMapSplitter = $('.trv-document-map-splitter').data(
      'kendoSplitter'
    );
    documentMapSplitter.resize(true);

    var parameterSplitter = $('.trv-parameters-splitter').data('kendoSplitter');
    parameterSplitter.resize(true);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
  font-family: Verdana, Arial;
  margin: 5px;
}
.viewer {
  height: 600px;
}

.viewer .k-splitter .k-scrollable {
  overflow: hidden;
}
#reportViewer1 {
  position: absolute;
  top: 70px;
  bottom: 10px;
  left: 10px;
  right: 10px;
  /* height: 1000px; */
  overflow: hidden;
  clear: both;
}
</style>
